import { render, staticRenderFns } from "./ProjectsFilter.vue?vue&type=template&id=b2f87d1a&"
import script from "./ProjectsFilter.vue?vue&type=script&lang=js&"
export * from "./ProjectsFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports